import ListItem from '../../utils/ListItem';

function AccidentListItem(props) {
  return (
    <ListItem
      primary={props.details || 'No details recorded.'}
      meta={props.date}
    />
  );
}

export default AccidentListItem;
